/*
*###############################################################################
*Module Name                   : TransactionController.js                      #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Wednesday, November 24th 2021, 10:33:10 am    #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import { isNull } from 'lodash';
import moment from 'moment'

export const getproducts = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let data = [];
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };
  await fetch(`${ApiURL}Product/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

export const getproductsSuppWise = async (supCode, txnType) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let data = [];
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };
  await fetch(`${ApiURL}Product/${supCode}/${txnType}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


export const getProductDetailsCode = async (productCode, loccode, type, supplier, customer) => {
  let data = [];
  let isSuccess = false;

  if (productCode === undefined || productCode === null || productCode === "") return data

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  let requestOptions = {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify({
      "productCode": productCode,
      "location": loccode,
      "txnType": type,
      "supplier": supplier,
      "customer": customer
    }),
  };

  await fetch(`${ApiURL}Product/TXNProductsearch`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        data = result.data
        isSuccess = true
      }
    })
    .catch(error => console.log("error", error))

  return { isSuccess: isSuccess, data: data }
}

// export const getProductDetailsCodeSuppWise = async (id, loccode, SuppCode, txnType) => {
//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")
//   let data = [];
//   let isSuccess = false
//   let requestOptions = {
//     method: "GET",
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${authToken}`
//     },
//     redirect: "follow",
//   };
//   await fetch(`${ApiURL}Product/Searchsw/${id}/${loccode}/${SuppCode}/${txnType}`, requestOptions)
//     .then(response => response.json())
//     .then(result => {
//       if (result.success) {
//         data = result.data
//         isSuccess = true
//       }
//     })
//     .catch(error => console.log("error", error))
//   return { isSuccess: isSuccess, data: data }
// }



// export const GetProductDetailsforTXNSupllierWiseProductScan = async (id, loccode, SuppCode, txnType) => {
//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")
//   let data = [];
//   let requestOptions = {
//     method: "GET",
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${authToken}`
//     },
//     redirect: "follow",
//   };
//   await fetch(`${ApiURL}Product/searchScanSup/${id}/${loccode}/${SuppCode}/${txnType}`, requestOptions)
//     .then(response => response.json())
//     .then(result => {
//       data = result.data
//     })
//     .catch(error => console.log("error", error))
//   //debugger;
//   return data
// }

// export const getProductDetailsCodeTXNScan = async (id, loccode, type) => {
//   let data = [];
//   if (id === undefined || id === null || id === "") return data

//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")

//   let requestOptions = {
//     method: "GET",
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${authToken}`
//     },
//     redirect: "follow",
//   };
//   await fetch(`${ApiURL}Product/searchScan/${id}/${loccode}/${type}`, requestOptions)
//     .then(response => response.json())
//     .then(result => {
//       data = result.data
//     })
//     .catch(error => console.log("error", error))
//   return data
// }


export const getLineDicTotal = (DataRow) => {

  let discount = 0.00;
  for (let i = 0; i < DataRow.length; i++) {
    // let txtDicPer = document.getElementById("DET_DISCPER" + i);
    // let txtAmt = document.getElementById("DET_AMOUNT" + i);
    if (DataRow[i].dcDET_DISCPER != null)
      discount = DataRow[i].dcDET_DISCPER > 0 ? parseFloat(discount) + (((parseFloat(DataRow[i].dcDET_AMOUNT) / (DataRow[i].dcDET_DISCPER > 0 ? 100 - (parseFloat(DataRow[i].dcDET_DISCPER)) : 1)) * 100) - parseFloat(DataRow[i].dcDET_AMOUNT)) : discount
    // let txtDicAmt = document.getElementById("DET_DISCAMT" + i);
    if (DataRow[i].dcDET_DISCAMT != null)
      discount = parseFloat(discount) + parseFloat(DataRow[i].dcDET_DISCAMT)
  }

  return discount;

}

export const NetCalculation = (grossAmount, DiscountPer, Additions, Deductions) => {
  return (grossAmount + Additions) - (((DiscountPer * grossAmount) / 100) + Deductions)
}

//************ Image Upload Function */
export const TxnFileUpload = async (picture) => {
  //debugger;
  let message;
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  if (picture != null) {
    let formdata = new FormData();
    formdata.append("img", picture)

    let requestOptions = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${authToken}`
      },
      body: formdata,
      redirect: 'follow'
    };

    await fetch(`${ApiURL}txn/file`, requestOptions)
      .then(response =>
        response.json()
          .then(responseData => {
            message = responseData.data
          })
      )
      .catch(error => console.log('error', error));
  } else {
    message = ""
  }

  return message
}
//************ Image Upload Function End*/

export const GetSearchTable = async (id, strSearchCtrl) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  let data = [];
  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  await fetch(`${ApiURL}myReport/searchTable/${id}/${strSearchCtrl}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

export const GetDetailAgainstBOM = async (txnType, strBOM, strFinishPro, location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  let bomData = [];
  let isSuccess = false;
  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify({
      "txnType": txnType,
      "bomCode": strBOM,
      "productCode": strFinishPro,
      "location": location
    })
  };

  await fetch(`${ApiURL}txn/getbom_data`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        bomData = result.data
        isSuccess = true
      }
    })
    .catch(error => console.log("error", error))
  return { isSuccess, bomData }
}

/* Here is the explanation for the code above:
1. GetRules is an async function that takes a parameter, strMenuCode.
2. ApiURL is a global variable declared in the main index.html file.
3. authToken is a global variable declared in the main index.html file.
4. myHeaders is a variable that contains the headers needed for the HTTP request.
5. data is an empty array that will contain the rules once the HTTP request is completed.
6. requestOptions is a variable that contains the requestOptions needed for the HTTP request.
7. The fetch command is used to create the HTTP request.
8. The await keyword is used to wait for the response from the HTTP request.
9. The response.json() method is used to convert the response to JSON.
10. The response is assigned to the data variable.
11. The data variable is returned by the function. */
export const GetRules = async (strMenuCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  var data = []
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  }
  await fetch(`${ApiURL}remote/${strMenuCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}



export const GetPermissionList = async (menu) => {
  try {
    const { ApiURL } = window.Links;
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const logUserType = authUser[2];
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      redirect: "follow",
    };

    const response = await fetch(`${ApiURL}login/menu/${logUserType}/${menu}`, requestOptions);
    const result = await response.json();

    return result.data;
  } catch (error) {
    console.error("Error fetching permission list:", error);
    return {};
  }
};


// export const GetPermissionList  = async (menu) => {
//   var data = []
//   var obj = JSON.parse(localStorage.getItem("authUser"))
//   var LogUserType = obj[2]
//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")
//   var requestOptions = {
//     method: "GET",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${authToken}`,
//     },
//     redirect: "follow",
//   }
//   return await fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
//     .then(async response => await response.json())
//     .then(result => {
//       return result.data
//     })
//     .catch(error => console.log("error", error))

// }


// export const GetPermissionList  = async (menu) => {
//   try {
//     const authUser = JSON.parse(localStorage.getItem("authUser"));
//     const LogUserType = authUser[2]; // Destructuring for consistent naming

//     const ApiURL = window.Links.ApiURL;
//     const authToken = localStorage.getItem("authToken");

//     const requestOptions = {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${authToken}`,
//       },
//       redirect: "follow",
//     };

//     const response = await fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions);
//     const result = await response.json();

//     if (result.success) {
//       return result.data;
//     }
//     else {
//       return null; // Handle the error or return a default value
//     }

//   } catch (error) {
//     console.error("Error fetching permission list:", error);
//     return null; // Handle the error or return a default value
//   }
// };


//**Send Permission request using FCM (FireBase Cloud Messege) */

export const SendFCM = async (body) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  var data = []
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify(body)
  }
  await fetch(`${ApiURL}remote`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

//Save Approve/Reject data to Db
export const SendApprovalData = async (body) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  var data = []
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify(body)
  }
  await fetch(`${ApiURL}remote/approve`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

//Cancel Transaction
export const CancelTransaction = async (body) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  var data = []
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify(body)
  }
  await fetch(`${ApiURL}txn/cancel`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

export const getTax = async (taxCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let data = [];
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };
  await fetch(`${ApiURL}CustomerTax/search/${taxCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data[0]
    })
    .catch(error => console.log("error", error))
  //debugger;
  return data
}


export const getSubDocs = async (excelItems) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let subdocsResponse = [];
  let msg = ""
  let status = 0
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      "TransactionSubDocsSet": excelItems
    }),
  }

  await fetch(`${ApiURL}TXN/subdocs`, requestOptions)
    .then(response => response.json())
    .then(result => {

      subdocsResponse = result.data
      msg = result.msg
      status = 1

    }).catch(error => console.log("error", error))

  return { subdocsResponse, msg, status }
}


export const getTxnLocations = async (type, user, isFromLoc, loggedLoc) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let data = [];
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };
  await fetch(`${ApiURL}txn/locations/${type}/${user}/${isFromLoc}/${loggedLoc}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  //debugger;
  return data
}

// export const getTxnProductPricemode = async (procode, location, pricemode, qty) => {
//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")
//   let data = [];
//   let requestOptions = {
//     method: "GET",
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${authToken}`
//     },
//     redirect: "follow",
//   };
//   await fetch(`${ApiURL}txn/pricemode/${procode}/${location}/${pricemode}/${qty}`, requestOptions)
//     .then(response => response.json())
//     .then(result => {
//       data = result.data
//     })
//     .catch(error => console.log("error", error))
//   //debugger;
//   return data
// }


export const getTxnProductPricemode = async (procode, stockCode, location, pricemode, qty, txnType) => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");


  if (pricemode == "") {
    return { status: 0 };
  }


  const requestBody = {
    "productCode": procode,
    "stockCode": stockCode,
    "location": location,
    "priceMode": pricemode,
    "qty": parseFloat(qty),
    "txnType": txnType
  };

  try {
    const response = await fetch(`${ApiURL}txn/pricemode`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify(requestBody),
    });

    const result = await response.json();
    return result.data || { status: 0 };
  } catch (error) {
    console.error("Request failed:", error);
    return { status: 0 };
  }
};



// export const LoadItemsFromExcell = async (supplier, items) => {
//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")

//   var excelResponseData = {
//     data: [],
//     success: false,
//   }

//   let requestOptions = {
//     method: "GET",
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${authToken}`
//     },
//     redirect: "follow",
//   };
//   await fetch(`${ApiURL}txn/pricemode/${procode}/${location}/${pricemode}/${qty}`, requestOptions)
//     .then(response => response.json())
//     .then(result => {
//       if (result.success) {
//         excelResponseData.data = result.data
//         excelResponseData.success = true
//       } else {
//         excelResponseData.data = result.data
//         excelResponseData.success = false
//       }
//     })
//     .catch(error => {
//       console.log("error", error)
//       excelResponseData.data = []
//       excelResponseData.success = false
//     })

//   return excelResponseData
// }


export const GetValidateProducts = async (body) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  var data = []
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify({
      "supplier": "1",
      "location": "2",
      "products": [
        {
          "TABLE_NAME": "M_TBLGROUP1",
          "LOC_CODE": "01039",
          "LOC_IP": "hehe"
        }
      ]
    })
  }
  await fetch(`${ApiURL}txn/validateproducts`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


export const GetValidateProductsSubDocs = async (body) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  var successDatatable = []
  var errorTable = []
  var taxDataTable = []
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify(body)
  }
  await fetch(`${ApiURL}txn/subdocProducts`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success) {

        var newArray = []
        if (result.data.length > 0) {
          result.data.map((item, index) => {
            var newItem = item;
            newItem.id = index + 1
            newItem.disable = true
            newArray.push(newItem)
          })
          successDatatable = newArray
          taxDataTable = JSON.parse(result.taxtable)
        }

        if (result.errortable.length > 0) {
          errorTable = result.errortable
        }

      }
    })
    .catch(error => console.log("error", error))
  return { successDatatable, errorTable, taxDataTable }
}

export const HandleDetailTable = async (DataRow, saleAssistantSelect, type, txn, refStockFreeze, process = 0, proSelect, RefCode) => {

  let DetTbl = []
  let DetrecCount = 0
  const idMapping = {};

  for (let i = 0; i < DataRow.length; i++) {

    if (DataRow[i].strDET_PROCODE.length != 0 && DataRow[i].strDET_PRODESC.length != 0) {

      let quantity = parseFloat(DataRow[i].dcDET_CASEQTY * DataRow[i].dcDET_CS) + parseFloat(DataRow[i].dcDET_UNITQTY) + parseFloat(DataRow[i].dcDET_FCASEQTY * DataRow[i].dcDET_CS) + parseFloat(DataRow[i].dcDET_FUNITQTY)

      if (txn.intTX_EXPCHKSIH == 1 && DataRow[i].dtDET_EXPCHECK == 1 && (txn.intTX_IS_BATCH_TXN == 1 || txn.intTX_CREATE_BATCH == 1)) {
        if (DataRow[i].dtDET_EXPDAET == null || DataRow[i].dtDET_EXPDAET < moment().format("YYYY-MM-DD")) {
          return {
            success: false, data: [], message: `Please Enter valid Expiry Date for the item ${DataRow[i].strDET_PROCODE} !`, recCount: DetrecCount
          }
        }
      }

      //if total quantity is zero and allow zero is false and process is 1 then return error
      if (txn.intTX_ALLOWZERO == 0 && txn.intTX_SAVEINVOICE == 1 && parseFloat(quantity) == 0) {
        return { success: false, data: [], message: "Please Enter quantity for the item " + DataRow[i].strDET_PROCODE + " !", recCount: DetrecCount }
      } else if (txn.intTX_ALLOWZERO == 0 && parseFloat(quantity) == 0) {
        return { success: false, data: [], message: "Please Enter quantity for the item " + DataRow[i].strDET_PROCODE + " !", recCount: DetrecCount }
      }

      //balance quantity check in each row with reference document
      if (RefCode != '' && txn.intTX_REFQTYCHK == 1 && DataRow[i].dcDET_BALQTY == 0 && txn.intTX_ALLOWZERO == 0 && txn.intTX_FIFO == 0) {
        return { success: false, data: [], message: "Item " + DataRow[i].strDET_PROCODE + " is fully used!", recCount: DetrecCount }
      }

      //checking if the remark is empty in each row
      if (txn.intTX_VALIDATE_DET_REMARKS == 1 && DataRow[i].strDET_REMCODE == "") {
        return { success: false, data: [], message: "In item " + DataRow[i].strDET_PROCODE + " remark is empty!", recCount: DetrecCount }
      }


      let lineNumber = parseFloat(DataRow[i].id)

      idMapping[DataRow[i].id] = i + 1;

      if (refStockFreeze == true) {

        if (parseFloat(DataRow[i].dcDET_UNITQTY) == 0 && parseFloat(DataRow[i].dcDET_CASEQTY) == 0 && DataRow[i].strDET_REMCODE == txn.strTX_STOCKFREEZE_RESON) {

          DetTbl.push(
            {
              strDET_TYPE: type.toUpperCase(),
              strDET_COMCODE: "000",
              strDET_RUNNO: "000",
              strDET_LOCCODE: "000",
              dcDET_LINENO: lineNumber,
              strDET_SACODE: saleAssistantSelect,
              strDET_PROCODE: DataRow[i].strDET_PROCODE,
              strDET_STOCKCODE: DataRow[i].strDET_STOCKCODE,
              strDET_PRODESC: DataRow[i].strDET_PRODESC,
              strDET_UNIT: DataRow[i].strDET_UNIT,
              dcDET_CS: parseFloat(DataRow[i].dcDET_CS.toString().replace(/,/g, "")),
              dtDET_EXPDAET: DataRow[i].dtDET_EXPDAET,
              strDET_EXPBATCH: DataRow[i].strDET_EXPBATCH,
              dcDET_SYSQTY: parseFloat(DataRow[i].dcDET_SYSQTY.toString().replace(/,/g, "")),
              dcDET_CASEQTY: parseFloat(DataRow[i].dcDET_CASEQTY.toString().replace(/,/g, "")),
              dcDET_UNITQTY: parseFloat(DataRow[i].dcDET_UNITQTY.toString().replace(/,/g, "")),
              dcDET_FCASEQTY: parseFloat(DataRow[i].dcDET_FCASEQTY.toString().replace(/,/g, "")),
              dcDET_FUNITQTY: parseFloat(DataRow[i].dcDET_FUNITQTY.toString().replace(/,/g, "")),
              dcDET_BALQTY: parseFloat(DataRow[i].dcDET_BALQTY.toString().replace(/,/g, "")),// == 0 ? (parseFloat(DataRow[i].dcDET_UNITQTY.toString().replace(/,/g, '')) + (parseFloat(DataRow[i].dcDET_CASEQTY.toString().replace(/,/g, '')) * parseFloat(DataRow[i].dcDET_CS.toString().replace(/,/g, '')))) : parseFloat(DataRow[i].dcDET_BALQTY.toString().replace(/,/g, '')),
              dcDET_FBALQTY: parseFloat(DataRow[i].dcDET_FBALQTY.toString().replace(/,/g, "")),
              dcDET_VARQTY: parseFloat(DataRow[i].dcDET_VARQTY.toString().replace(/,/g, "")),
              dcDET_OSPRICE: parseFloat(DataRow[i].dcDET_OSPRICE.toString().replace(/,/g, "")),
              dcDET_OCPRICE: parseFloat(DataRow[i].dcDET_OCPRICE.toString().replace(/,/g, "")),
              dcDET_OAPRICE: parseFloat(DataRow[i].dcDET_OAPRICE.toString().replace(/,/g, "")),
              dcDET_SPRICE: parseFloat(DataRow[i].dcDET_SPRICE.toString().replace(/,/g, "")),
              dcDET_CPRICE: parseFloat(DataRow[i].dcDET_CPRICE.toString().replace(/,/g, "")),
              dcDET_ACOST: parseFloat(DataRow[i].dcDET_ACOST.toString().replace(/,/g, "")),
              dcDET_APRICE: parseFloat(DataRow[i].dcDET_APRICE.toString().replace(/,/g, "")),
              dcDET_DISCPER: parseFloat(DataRow[i].dcDET_DISCPER.toString().replace(/,/g, "")),
              dcDET_DISCAMT: parseFloat(DataRow[i].dcDET_DISCAMT.toString().replace(/,/g, "")),
              dcDET_AMOUNT: parseFloat(DataRow[i].dcDET_AMOUNT.toString().replace(/,/g, "")),
              dcDET_SPRICE_OLD: parseFloat(DataRow[i].dcDET_SPRICE_OLD.toString().replace(/,/g, "")),
              dcDET_CPRICE_OLD: parseFloat(DataRow[i].dcDET_CPRICE_OLD.toString().replace(/,/g, "")),
              strDET_REMCODE: DataRow[i].strDET_REMCODE,
              id: DataRow[i].id,
            }
          )
        } else if (parseFloat(DataRow[i].dcDET_UNITQTY) != 0 || parseFloat(DataRow[i].dcDET_CASEQTY) != 0) {

          DetTbl.push(
            {
              strDET_TYPE: type.toUpperCase(),
              strDET_COMCODE: "000",
              strDET_RUNNO: "000",
              strDET_LOCCODE: "000",
              dcDET_LINENO: lineNumber,
              strDET_SACODE: saleAssistantSelect,
              strDET_PROCODE: DataRow[i].strDET_PROCODE,
              strDET_STOCKCODE: DataRow[i].strDET_STOCKCODE,
              strDET_PRODESC: DataRow[i].strDET_PRODESC,
              strDET_UNIT: DataRow[i].strDET_UNIT,
              dcDET_CS: parseFloat(DataRow[i].dcDET_CS.toString().replace(/,/g, "")),
              dtDET_EXPDAET: DataRow[i].dtDET_EXPDAET,
              strDET_EXPBATCH: DataRow[i].strDET_EXPBATCH,
              dcDET_SYSQTY: parseFloat(DataRow[i].dcDET_SYSQTY.toString().replace(/,/g, "")),
              dcDET_CASEQTY: parseFloat(DataRow[i].dcDET_CASEQTY.toString().replace(/,/g, "")),
              dcDET_UNITQTY: parseFloat(DataRow[i].dcDET_UNITQTY.toString().replace(/,/g, "")),
              dcDET_FCASEQTY: parseFloat(DataRow[i].dcDET_FCASEQTY.toString().replace(/,/g, "")),
              dcDET_FUNITQTY: parseFloat(DataRow[i].dcDET_FUNITQTY.toString().replace(/,/g, "")),
              dcDET_BALQTY: parseFloat(DataRow[i].dcDET_BALQTY.toString().replace(/,/g, "")),// == 0 ? (parseFloat(DataRow[i].dcDET_UNITQTY.toString().replace(/,/g, '')) + (parseFloat(DataRow[i].dcDET_CASEQTY.toString().replace(/,/g, '')) * parseFloat(DataRow[i].dcDET_CS.toString().replace(/,/g, '')))) : parseFloat(DataRow[i].dcDET_BALQTY.toString().replace(/,/g, '')),
              dcDET_FBALQTY: parseFloat(DataRow[i].dcDET_FBALQTY.toString().replace(/,/g, "")),
              dcDET_VARQTY: parseFloat(DataRow[i].dcDET_VARQTY.toString().replace(/,/g, "")),
              dcDET_OSPRICE: parseFloat(DataRow[i].dcDET_OSPRICE.toString().replace(/,/g, "")),
              dcDET_OCPRICE: parseFloat(DataRow[i].dcDET_OCPRICE.toString().replace(/,/g, "")),
              dcDET_OAPRICE: parseFloat(DataRow[i].dcDET_OAPRICE.toString().replace(/,/g, "")),
              dcDET_SPRICE: parseFloat(DataRow[i].dcDET_SPRICE.toString().replace(/,/g, "")),
              dcDET_CPRICE: parseFloat(DataRow[i].dcDET_CPRICE.toString().replace(/,/g, "")),
              dcDET_ACOST: parseFloat(DataRow[i].dcDET_ACOST.toString().replace(/,/g, "")),
              dcDET_APRICE: parseFloat(DataRow[i].dcDET_APRICE.toString().replace(/,/g, "")),
              dcDET_DISCPER: parseFloat(DataRow[i].dcDET_DISCPER.toString().replace(/,/g, "")),
              dcDET_DISCAMT: parseFloat(DataRow[i].dcDET_DISCAMT.toString().replace(/,/g, "")),
              dcDET_AMOUNT: parseFloat(DataRow[i].dcDET_AMOUNT.toString().replace(/,/g, "")),
              dcDET_SPRICE_OLD: parseFloat(DataRow[i].dcDET_SPRICE_OLD.toString().replace(/,/g, "")),
              dcDET_CPRICE_OLD: parseFloat(DataRow[i].dcDET_CPRICE_OLD.toString().replace(/,/g, "")),
              strDET_REMCODE: DataRow[i].strDET_REMCODE,
              id: DataRow[i].id,
            }
          )
        }

      } else {
        DetTbl.push(
          {
            strDET_TYPE: type.toUpperCase(),
            strDET_COMCODE: "000",
            strDET_RUNNO: "000",
            strDET_LOCCODE: "000",
            dcDET_LINENO: lineNumber,
            strDET_SACODE: saleAssistantSelect,
            strDET_PROCODE: DataRow[i].strDET_PROCODE,
            strDET_STOCKCODE: DataRow[i].strDET_STOCKCODE,
            strDET_PRODESC: DataRow[i].strDET_PRODESC,
            strDET_UNIT: DataRow[i].strDET_UNIT,
            dcDET_CS: parseFloat(DataRow[i].dcDET_CS.toString().replace(/,/g, "")),
            dtDET_EXPDAET: DataRow[i].dtDET_EXPDAET,
            strDET_EXPBATCH: DataRow[i].strDET_EXPBATCH,
            dcDET_SYSQTY: parseFloat(DataRow[i].dcDET_SYSQTY.toString().replace(/,/g, "")),
            dcDET_CASEQTY: parseFloat(DataRow[i].dcDET_CASEQTY.toString().replace(/,/g, "")),
            dcDET_UNITQTY: parseFloat(DataRow[i].dcDET_UNITQTY.toString().replace(/,/g, "")),
            dcDET_FCASEQTY: parseFloat(DataRow[i].dcDET_FCASEQTY.toString().replace(/,/g, "")),
            dcDET_FUNITQTY: parseFloat(DataRow[i].dcDET_FUNITQTY.toString().replace(/,/g, "")),
            dcDET_BALQTY: parseFloat(DataRow[i].dcDET_BALQTY.toString().replace(/,/g, "")),// == 0 ? (parseFloat(DataRow[i].dcDET_UNITQTY.toString().replace(/,/g, '')) + (parseFloat(DataRow[i].dcDET_CASEQTY.toString().replace(/,/g, '')) * parseFloat(DataRow[i].dcDET_CS.toString().replace(/,/g, '')))) : parseFloat(DataRow[i].dcDET_BALQTY.toString().replace(/,/g, '')),
            dcDET_FBALQTY: parseFloat(DataRow[i].dcDET_FBALQTY.toString().replace(/,/g, "")),
            dcDET_VARQTY: parseFloat(DataRow[i].dcDET_VARQTY.toString().replace(/,/g, "")),
            dcDET_OSPRICE: parseFloat(DataRow[i].dcDET_OSPRICE.toString().replace(/,/g, "")),
            dcDET_OCPRICE: parseFloat(DataRow[i].dcDET_OCPRICE.toString().replace(/,/g, "")),
            dcDET_OAPRICE: parseFloat(DataRow[i].dcDET_OAPRICE.toString().replace(/,/g, "")),
            dcDET_SPRICE: parseFloat(DataRow[i].dcDET_SPRICE.toString().replace(/,/g, "")),
            dcDET_CPRICE: parseFloat(DataRow[i].dcDET_CPRICE.toString().replace(/,/g, "")),
            dcDET_ACOST: parseFloat(DataRow[i].dcDET_ACOST.toString().replace(/,/g, "")),
            dcDET_APRICE: parseFloat(DataRow[i].dcDET_APRICE.toString().replace(/,/g, "")),
            dcDET_DISCPER: parseFloat(DataRow[i].dcDET_DISCPER.toString().replace(/,/g, "")),
            dcDET_DISCAMT: parseFloat(DataRow[i].dcDET_DISCAMT.toString().replace(/,/g, "")),
            dcDET_AMOUNT: parseFloat(DataRow[i].dcDET_AMOUNT.toString().replace(/,/g, "")),
            dcDET_SPRICE_OLD: parseFloat(DataRow[i].dcDET_SPRICE_OLD.toString().replace(/,/g, "")),
            dcDET_CPRICE_OLD: parseFloat(DataRow[i].dcDET_CPRICE_OLD.toString().replace(/,/g, "")),
            strDET_REMCODE: txn.intTX_BOM == 1 ? proSelect : DataRow[i].strDET_REMCODE,
            id: DataRow[i].id,
          }
        )
      }


      //debugger;
      DetrecCount++
    }
  }



  return { success: true, data: DetTbl, message: "", recCount: DetrecCount, idMapping: idMapping }
}


export const getCheckSIH = async (items, location, type) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let sihResponse = [];
  let msg = ""
  let status = 0
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      "itemlist": items,
      "location": location,
      "txnType": type
    }),
  }

  await fetch(`${ApiURL}TXN/checksih`, requestOptions)
    .then(response => response.json())
    .then(result => {

      if (result.success) {

        sihResponse = result.data
        msg = result.msg
        status = 1

      } else {
        sihResponse = []
        msg = result.msg
        status = 0
      }


    }).catch(error => console.log("error", error))

  return { sihResponse, msg, status }
}


export const getCheckSIHBOM = async (items, location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  let sihResponse = [];
  let msg = ""
  let status = 0
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      "itemlist": items,
      "location": location,
    }),
  }

  await fetch(`${ApiURL}TXN/checksih`, requestOptions)
    .then(response => response.json())
    .then(result => {

      sihResponse = result.data
      msg = result.msg
      status = 1

    }).catch(error => console.log("error", error))

  return { sihResponse, msg, status }
}



export const GetValidateExcelProducts = async (supplier, location, type, body, SetLoadingAlert, SetLoadingAlerttitle) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  var data = []
  var msg = ""
  var status = ""
  var success = false
  var detailTable = []
  var taxTable = []
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify({
      Supplier: supplier,
      Location: location,
      TxnType: type,
      ExcelDetailTable: body
    })
  }

  SetLoadingAlert(true)
  SetLoadingAlerttitle("Loading Data...")

  await fetch(`${ApiURL}txn/Product/Excel`, requestOptions)
    .then(response => response.json())
    .then(result => {
      SetLoadingAlert(false)
      if (result.success) {
        data = result.data
        msg = result.msg
        status = result.status
        success = result.success
        detailTable = JSON.parse(result.details)
        taxTable = JSON.parse(result.taxdetails)
      } else {
        msg = result.msg
        status = result.status
        success = result.success
        detailTable = []
        taxTable = []
      }
    })
    .catch(error => {
      SetLoadingAlert(false)
      console.log("error", error)
    })
  return { success: success, data: data, message: msg, status: status, detailTable: detailTable, taxTable: taxTable }
}


export const GetSupplierTax = async (supplier) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };

  await fetch(`${ApiURL}txn/suppliertax/${supplier}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        data = result.data
      }
    })
    .catch(error => console.log("error", error))
  return data
}


export const GetDetailReasonTypes = async (type) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
    };

    const response = await fetch(`${ApiURL}ReasonType/select/${type}`, requestOptions);
    const result = await response.json();

    if (result.success) {
      return { success: true, data: result.data }
    } else {
      return { success: false, data: [] }
    }
  } catch (error) {
    console.error("Error:", error);
    return { success: false, data: [] }
  }
};

export const GetHeaderReasonTypes = async (type) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
    };

    const response = await fetch(`${ApiURL}ReasonType/select/summary/${type}`, requestOptions);
    const result = await response.json();

    if (result.success) {
      return { success: true, data: result.data }
    } else {
      return { success: false, data: [] }
    }
  } catch (error) {
    console.error("Error:", error);
    return { success: false, data: [] }
  }
};


export const GetShelfManager = async (type, user, location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };

  await fetch(`${ApiURL}txn/shelfmanager/${type}/${user}/${location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        data = result.data
      }
    })
    .catch(error => console.log("error", error))
  return data
}


export const MobileManTransaction = async (type, user, location, remark, supplier, customer) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  let detail = []
  let tax = []

  let requestOptions = {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
    body: JSON.stringify({
      "txnType": type,
      "User": user,
      "LocCode": location,
      "Remark": remark,
      "customer": customer,
      "supplier": supplier
    })
  };

  await fetch(`${ApiURL}txn/ManTransaction`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        detail = result.data
        tax = result.tax
      }
    })
    .catch(error => console.log("error", error))
  return { detail, tax }
}


export const GetTxn = async (type) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  var data = []
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };

  await fetch(`${ApiURL}txn/${type}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        data = result.data
      }
    })
    .catch(error => console.log("error", error))
  return data

}


export const GetMultiplePrices = async (product, location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var isSuccess = false
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };

  await fetch(`${ApiURL}txn/multiplePrice/${product}/${location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        data = result.data
        isSuccess = true
      }
    })
    .catch(error => console.log("error", error))
  return { data, isSuccess }
}





export const GetReferenceDoc = async (type, refTypeSelected, fromLocationSelect, toLocationSelect, runno) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var isSuccess = false

  await fetch(`${ApiURL}txn/single/refTxn`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        txnType: type,
        refTxnType: refTypeSelected,
        fromLoc: fromLocationSelect,
        toLoc: toLocationSelect,
        runnumber: runno
      })
    }
  ).then(Response => Response.json())
    .then(async (responseData) => {
      if (responseData.success) {
        data = responseData.data.objTXN_DETSAVE
        isSuccess = true
      }
    }).catch((error) => {

    });
  return { data, isSuccess }
}


export const GetAutoOrder = async (supplier, location, fromDate, toDate, numDays, txnType) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var tax = []
  var isSuccess = false

  await fetch(`${ApiURL}txn/autoorder`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        txnType: txnType,
        supplier: supplier,
        location: location,
        startDate: fromDate,
        endDate: toDate,
        orderDays: numDays
      })
    }
  ).then(Response => Response.json())
    .then(async (responseData) => {
      if (responseData.success) {
        data = responseData.data
        tax = responseData.tax
        isSuccess = true
      }
    }).catch((error) => {

    });
  return { data, isSuccess, tax }
}


export const transOBJ = [{
  dcDET_ACOST: 0,
  dcDET_ACOST_OLD: 0,
  dcDET_AMOUNT: 0,
  dcDET_APRICE: 0,
  dcDET_BALQTY: 0,
  dcDET_FBALQTY: 0,
  dcDET_CASEQTY: 0,
  dcDET_CPRICE: 0,
  dcDET_CS: 1,
  dcDET_DISCAMT: 0,
  dcDET_DISCPER: 0,
  dcDET_FCASEQTY: 0,
  dcDET_FUNITQTY: 0,
  dcDET_OAPRICE: 0,
  dcDET_OCPRICE: 0,
  dcDET_OSPRICE: 0,
  dcDET_SPRICE: 0,
  dcDET_SYSQTY: 0,
  dcDET_UNITQTY: 0,
  dcDET_VARQTY: 0,
  dtDET_EXPCHECK: 0,
  dtDET_ISBATCH: 0,
  dtDET_EXPDAET: "1900-01-01",
  strDET_COMCODE: "",
  strDET_EXPBATCH: "",
  strDET_LOCCODE: "",
  strDET_PROCODE: "",
  strDET_PROCOLOR: "",
  strDET_PRODESC: "",
  strDET_PROSIZE: "",
  strDET_REMCODE: "",
  strDET_RUNNO: "",
  strDET_SACODE: "",
  strDET_STOCKCODE: "",
  strDET_TYPE: "",
  strDET_UNIT: "",
  variant_ENABLE: false,
  disable: false,
  dcDET_SPRICE_OLD: 0,
  isDecimal: 0,
  dbPackPrice: 0,
  id: 1,
  openItem: 0,
  innerCS: [{
    "value": 1,
    "label": "1",
  }],
  defaultCS: 1,
  fixGP: 0,
}]


export const PaymentObj = [{
  id: 1,
  Paycode: "",
  PayCodeDisable: false,
  Paydesc: "",
  PayDetcode: "",
  PayDetcodeDesable: true,
  PayDetName: "",
  PayAmount: 0,
  PayAmountDisable: true,
  AccountCode: "",
  AccountCodeDisable: true,
  ExpDate: "",
  ExpDateDisable: true,
  PayDetFormat: "",
}]




export const getLocationSupplier = async (location) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${ApiURL}txn/LocationSupplier/${location}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    });

    const responseData = await response.json();

    if (responseData.success) {
      return { data: responseData.data, isSuccess: true };
    } else {
      return { data: [], isSuccess: false };
    }
  } catch (error) {
    return { data: [], isSuccess: false };
  }
};


export const getUserPermission = async (permissiondata) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${ApiURL}login/userpermission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(permissiondata),
    });

    const responseData = await response.json();

    if (responseData.success) {
      return { data: responseData.data, isSuccess: true, msg: responseData.msg };
    } else {
      return { data: [], isSuccess: false, msg: responseData.msg };
    }
  } catch (error) {
    return { data: [], isSuccess: false, msg: responseData.msg };
  }
};



export const RemarkValidation = async (remark, user) => {

  try {

    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${ApiURL}txn/remarkvalidation/${remark}/${user}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    });

    const responseData = await response.json();

    if (responseData.success) {
      return { data: responseData.data, isSuccess: true };
    } else {
      return { data: false, isSuccess: false };
    }


  } catch (error) {
    return { data: false, isSuccess: false };
  }


}

export const GetSupplierDetails = async (CodeFind, type) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }

    };
    const response = await fetch(`${ApiURL}txn/txnSupplier/${type}/${CodeFind}`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.success) {
        return { success: true, data: responseData.data, message: responseData.msg };
      } else {
        return { success: false, data: {}, message: responseData.msg };
      }
    } else {
      return { success: false, data: {}, message: responseData.msg };
    }

  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: {}, message: error };
  }
}


export const GetCustomerDetails = async (CodeFind, type) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }

    };
    const response = await fetch(`${ApiURL}txn/txnCustomer/${type}/${CodeFind}`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.success) {
        return { success: true, data: responseData.data, message: responseData.msg };
      } else {
        return { success: false, data: {}, message: responseData.msg };
      }
    } else {
      return { success: false, data: {}, message: responseData.msg };
    }

  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: {}, message: error };
  }
}


export const GetSalesAssistDetails = async (CodeFind) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }

    };
    const response = await fetch(`${ApiURL}salesassistant/search/${CodeFind}`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.success && responseData.data.length > 0) {
        return { success: true, data: responseData.data[0] };
      } else {
        return { success: false, data: {} };
      }
    } else {
      return { success: false, data: {} };
    }

  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: {} };
  }
}

export const GetProduct = async (CodeFind, location) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }

    };
    const response = await fetch(`${ApiURL}Product/search_location/${CodeFind}/${location}`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.success && responseData.data.length > 0) {
        return { success: true, data: responseData.data[0] };
      } else {
        return { success: false, data: {} };
      }
    } else {
      return { success: false, data: {} };
    }

  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: {} };
  }
}

export const GetBOM = async (CodeFind, location) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }

    };
    const response = await fetch(`${ApiURL}BOM/search/${CodeFind}/${location}`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.success && responseData.data.length > 0) {
        return { success: true, data: responseData.data[0] };
      } else {
        return { success: false, data: {} };
      }
    } else {
      return { success: false, data: {} };
    }

  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: {} };
  }
}

// const TxnTotalCal = () => {

//   let DetTbl = []

//   let GrossAmt = 0
//   let NetAmt = 0

//   for (let i = 0; i < DataRow.length; i++) {

//     let txtcs = DataRow[i].dcDET_CS
//     let txtcode = DataRow[i].strDET_PROCODE

//     let txtunitqty = DataRow[i].dcDET_UNITQTY

//     let txtcaseqty = DataRow[i].dcDET_CASEQTY

//     let txtdiscper = DataRow[i].dcDET_DISCPER

//     let txtdicamt = DataRow[i].dcDET_DISCAMT

//     let txtamt = DataRow[i].dcDET_AMOUNT

//     let freeUnit = DataRow[i].dcDET_FUNITQTY

//     let txtsprice = DataRow[i].dcDET_SPRICE

//     let txtcprice = DataRow[i].dcDET_CPRICE

//     let txtaprice = DataRow[i].dcDET_APRICE

//     let priceMode = 0
//     if (txn.strTX_PRICEMODE == "C" || txn.strTX_PRICEMODE == "c") {
//       priceMode = parseFloat(txtcprice.toString().replace(",", ""))
//     } else if (txn.strTX_PRICEMODE == "S" || txn.strTX_PRICEMODE == "s") {
//       priceMode = parseFloat(txtsprice.toString().replace(",", ""))
//     } else if (txn.strTX_PRICEMODE == "A" || txn.strTX_PRICEMODE == "a") {
//       priceMode = parseFloat(txtaprice.toString().replace(",", ""))
//     } else if (txn.strTX_PRICEMODE == "P" || txn.strTX_PRICEMODE == "p") {
//       priceMode = parseFloat((pp / cs).toString().replace(",", ""))
//     }
//     if (txtcode.length != 0) {
//       let grossAmount = 0
//       if (txn.intTX_PRODUCTION == 1) {
//         grossAmount = parseFloat(priceMode) * (parseFloat(txtcaseqty) * parseFloat(txtcs) + parseFloat(txtunitqty - freeUnit))
//       } else {
//         grossAmount = parseFloat(priceMode) * (parseFloat(txtcaseqty) * parseFloat(txtcs) + parseFloat(txtunitqty))
//       }

//       let NetAmount = grossAmount - ((parseFloat(txtdiscper) * grossAmount) / 100 + parseFloat(txtdicamt))

//       GrossAmt = GrossAmt + parseFloat(NetAmount)

//       NetAmt = NetAmt + parseFloat(NetAmount)
//     }
//   }
//   //
//   SetGrossTotal(GrossAmt) //set gross total gross amount


//   SetTxDiscountAmt((parseFloat(txDiscount) * NetAmt) / 100)

//   if (txn.intTX_PRODUCTION == 1) {
//     if (NetAmt > 0) {
//       SetTxDeduction(NetAmt)
//       SetTxAddition(0)
//       NetAmt = 0
//       SetTxNetAmount(NetAmt)
//       return
//     } else {
//       SetTxAddition(NetAmt * -1)
//       SetTxDeduction(0)
//       NetAmt = 0
//       SetTxNetAmount(NetAmt)
//       return
//     }

//     NetAmt = NetAmt + parseFloat(txAddition) - parseFloat(txDeduction)
//   } else {
//     NetAmt = NetAmt + parseFloat(txAddition) - parseFloat(txDeduction)
//   }


//   NetAmt = NetAmt - (parseFloat(txDiscount) * NetAmt) / 100

//   var TaxInclusive = 0;
//   var TaxExclusive = 0;

//   taxTable.map((item, index) => {

//     if (item.taxInclusive) {
//       TaxInclusive = TaxInclusive + (parseFloat(item.grossAmt) * parseFloat(item.taxRate)) / (parseFloat(100) + parseFloat(item.taxRate))
//     } else {
//       TaxExclusive = TaxExclusive + (parseFloat(item.grossAmt) * parseFloat(item.taxRate)) / parseFloat(100)
//     }

//   })

//   NetAmt = NetAmt + parseFloat(TaxExclusive)
//   // alert("Tax")
//   SetTxNetAmount(parseFloat(NetAmt).toFixed(txnDecimalAmt))

//   setTimeout(() => {
//     SetLineDisc(getLineDicTotal(DataRow))
//   }, 1)


//   return DetTbl
// }




export const calculateFromAndToValue = async (DataRow, proSelect, txn) => {
  let fromValue = 0;
  let toValue = 0;

  if (DataRow.length > 0 && DataRow.some(x => x.strDET_PROCODE !== "")) {
    // Find base product from DataRow
    const baseProduct = DataRow.find(x => x.strDET_PROCODE === proSelect);

    if (baseProduct !== undefined) {
      let priceMode = 0;
      if (txn.strTX_PRICEMODE.toLowerCase() === "c") {
        priceMode = parseFloat(baseProduct.dcDET_CPRICE.toString().replace(",", ""));
      } else if (txn.strTX_PRICEMODE.toLowerCase() === "s") {
        priceMode = parseFloat(baseProduct.dcDET_SPRICE.toString().replace(",", "")); // sell;
      } else if (txn.strTX_PRICEMODE.toLowerCase() === "a") {
        priceMode = parseFloat(baseProduct.dcDET_ACOST);
      } else if (txn.strTX_PRICEMODE.toLowerCase() === "p") {
        priceMode = parseFloat(baseProduct.dbPackPrice) / parseFloat(baseProduct.dcDET_CS);
      }

      const freeCaseQty = (txn.strTX_PRICEMODE.toLowerCase() === "c" || txn.strTX_PRICEMODE.toLowerCase() === "a")
        ? parseFloat(baseProduct.dcDET_FCASEQTY) / parseFloat(baseProduct.dcDET_CS)
        : parseFloat(baseProduct.dcDET_FCASEQTY);

      toValue = parseFloat(priceMode) * parseFloat(freeCaseQty);
    }

    // Calculate from value from other values except baseProduct
    DataRow.forEach(x => {
      if (x.strDET_PROCODE !== proSelect) {
        let priceMode = 0;
        if (txn.strTX_PRICEMODE.toLowerCase() === "c") {
          priceMode = parseFloat(x.dcDET_CPRICE.toString().replace(",", ""));
        } else if (txn.strTX_PRICEMODE.toLowerCase() === "s") {
          priceMode = parseFloat(x.dcDET_SPRICE.toString().replace(",", "")); // sell;
        } else if (txn.strTX_PRICEMODE.toLowerCase() === "a") {
          priceMode = parseFloat(x.dcDET_ACOST);
        } else if (txn.strTX_PRICEMODE.toLowerCase() === "p") {
          priceMode = parseFloat(x.dbPackPrice) / parseFloat(x.dcDET_CS);
        }

        const freeCaseQty = (txn.strTX_PRICEMODE.toLowerCase() === "c" || txn.strTX_PRICEMODE.toLowerCase() === "a")
          ? parseFloat(x.dcDET_FCASEQTY) / parseFloat(x.dcDET_CS)
          : parseFloat(x.dcDET_FCASEQTY);

        fromValue += parseFloat(priceMode) * parseFloat(freeCaseQty);
      }
    });
  }

  return { fromValue, toValue };
}



export const GetMonthend = async (location) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
    };

    const response = await fetch(`${ApiURL}txn/current_monthend/${location}`, requestOptions);
    const result = await response.json();

    if (result.success) {
      return { success: true, data: result.data }
    } else {
      return { success: false, data: result.data }
    }
  } catch (error) {
    console.error("Error:", error);
    return { success: false, data: { month: 1, year: 1900 } }
  }
};


export const UpdateUnitsWithExcel = async (DataRow, excel, txn) => {


  var updatedDetailWithUnitQty = DataRow.map((item, index) => {

    let filtered_Item = excel.find(x => x.stock_Code == item.strDET_STOCKCODE);
    //let filtered_Ref_Item = RefDataRow.find(x => x.strDET_STOCKCODE == item.strDET_STOCKCODE);

    //const { dcDET_BALQTY, dcDET_CS } = filtered_Ref_Item
    const { dcDET_BALQTY, dcDET_CS } = item
    const { intTX_CASEQTY, intTX_UNITQTY, intTX_REFQTYCHK } = txn

    if (filtered_Item) {

      //if the reference qty check is enabled and uploaded qty if greater than balance qty then use balance qty then assign balance qty to unit qty
      if (parseFloat(filtered_Item?.unit ?? 0) > parseFloat(dcDET_BALQTY) && intTX_REFQTYCHK == 1) {

        if (intTX_CASEQTY == 1 && intTX_UNITQTY == 1) {

          item.dcDET_CASEQTY = Math.floor(parseFloat(dcDET_BALQTY) / parseFloat(dcDET_CS));
          item.dcDET_UNITQTY = parseFloat(dcDET_BALQTY) % parseFloat(dcDET_CS);
          item.strDET_REMCODE = filtered_Item?.line_Remark ?? "";

        } else if (intTX_CASEQTY == 1 && intTX_UNITQTY == 0) {

          item.dcDET_CASEQTY = Math.floor(parseFloat(dcDET_BALQTY) / parseFloat(dcDET_CS));
          item.strDET_REMCODE = filtered_Item?.line_Remark ?? "";

        } else if (intTX_CASEQTY == 0 && intTX_UNITQTY == 1) {

          item.dcDET_UNITQTY = parseFloat(dcDET_BALQTY);
          item.strDET_REMCODE = filtered_Item?.line_Remark ?? "";

        } else {

          item.dcDET_UNITQTY = parseFloat(dcDET_BALQTY);
          item.strDET_REMCODE = filtered_Item?.line_Remark ?? "";

        }

      } else {

        if (intTX_CASEQTY == 1 && intTX_UNITQTY == 1) {

          item.dcDET_CASEQTY = Math.floor(parseFloat(filtered_Item?.unit ?? 0) / parseFloat(dcDET_CS));
          item.dcDET_UNITQTY = parseFloat(filtered_Item?.unit ?? 0) % parseFloat(dcDET_CS);
          item.strDET_REMCODE = filtered_Item?.line_Remark ?? "";

        } else if (intTX_CASEQTY == 1 && intTX_UNITQTY == 0) {

          item.dcDET_CASEQTY = Math.floor(parseFloat(filtered_Item?.unit ?? 0) / parseFloat(dcDET_CS));
          item.strDET_REMCODE = filtered_Item?.line_Remark ?? "";

        } else if (intTX_CASEQTY == 0 && intTX_UNITQTY == 1) {

          item.dcDET_UNITQTY = parseFloat(filtered_Item?.unit ?? 0);
          item.strDET_REMCODE = filtered_Item?.line_Remark ?? "";

        } else {

          item.dcDET_UNITQTY = parseFloat(filtered_Item?.unit ?? 0);

        }
      }

    }
    return item;
  })

  return updatedDetailWithUnitQty;

};


export const getApprovalStatusAndMessage = async (remoteData) => {
  let approvalStatus = 3;
  let alertMessage = '';

  const filterCurrentApprovals = remoteData.filter(item => item.isCurrent == true);

  if (filterCurrentApprovals.length > 0) {
    const statuses = filterCurrentApprovals.map(item => item.shrtRA_APPROVED);
    const hasPending = statuses.includes(0);
    const hasApproved = statuses.includes(1);
    const hasRejected = statuses.includes(2);
    const hasReview = statuses.includes(3);

    if (statuses.every(status => status === 1)) {
      approvalStatus = 1; // All approvals are 1
      alertMessage = "The transaction is approved and cannot be edited.";
    } else if (statuses.every(status => status === 2)) {
      approvalStatus = 2; // All approvals are 2
      alertMessage = "The transaction is rejected and cannot be edited.";
    } else if (statuses.every(status => status === 0)) {
      approvalStatus = 0; // All approvals are 0
      alertMessage = "The transaction is pending approval and cannot be edited.";
    } else if (statuses.every(status => status === 3)) {
      approvalStatus = 3; // All approvals are 3
      alertMessage = "The transaction is under review and can be edited.";
    } else if (hasPending) {
      if (hasApproved && !hasRejected && !hasReview) {
        approvalStatus = 0; // Scenario 5
        alertMessage = "The transaction is pending approval and cannot be edited.";
      } else if (hasRejected && !hasApproved && !hasReview) {
        approvalStatus = 2; // Scenario 6
        alertMessage = "The transaction is rejected and cannot be edited.";
      } else if (hasReview && !hasApproved && !hasRejected) {
        approvalStatus = 3; // Scenario 7
        alertMessage = "The transaction is under review and can be edited.";
      } else if (hasApproved && hasRejected && hasPending) {
        approvalStatus = 2; // Scenario 12
        alertMessage = "The transaction is rejected and cannot be edited.";
      } else if (hasApproved && hasReview && hasPending) {
        approvalStatus = 1; // Scenario 13
        alertMessage = "The transaction is approved and cannot be edited.";
      } else if (hasRejected && hasReview && hasPending) {
        approvalStatus = 2; // Scenario 14
        alertMessage = "The transaction is rejected and cannot be edited.";
      } else if (hasApproved && hasRejected && hasReview && hasPending) {
        approvalStatus = 2; // Scenario 15
        alertMessage = "The transaction is rejected and cannot be edited.";
      }
    } else if (hasRejected) {
      if (hasApproved && !hasPending && !hasReview) {
        approvalStatus = 2; // Scenario 8
        alertMessage = "The transaction is rejected and cannot be edited.";
      } else if (hasReview && !hasPending && !hasApproved) {
        approvalStatus = 2; // Scenario 10
        alertMessage = "The transaction is rejected and cannot be edited.";
      }
    } else if (hasApproved) {
      if (hasReview && !hasPending && !hasRejected) {
        approvalStatus = 1; // Scenario 9
        alertMessage = "The transaction is approved and cannot be edited.";
      }
    }
  }

  return { approvalStatus, alertMessage };
};




export const FocusOnEvent = async (e, txn) => {
  if (e == "txtFromLoc") {
    if (txn.strTX_DESTINV != "N" && txn.strTX_DESTINV != "") {
      document.getElementById("txtToLoc").focus()
      return
    } else if (txn.intTX_SUPPLIER == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtSupplier").focus()
      return
    } else if (txn.intTX_CUSTOMER == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtCustomer").focus()
      return
    } else if (txn.intTX_SALESBY == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtSA").focus()
      return
    } else if (txn.intTX_PRICEMODE == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtPriceMode").focus()
      return
    } else if (txn.strTX_REFTYPES != "" && txn.intTX_BOM == 0) {
      document.getElementById("txtRefNo").focus()
      return
    } else if (txn.intTX_BOM == 0) {
      document.getElementById("txtRemarks1") ? document.getElementById("txtRemarks1").focus() : null
      return
    }
  }
  if (e == "txtToLoc") {
    if (1 == 2) {
      document.getElementById("txtDeliLoc").focus()
      return
    } else if (txn.intTX_SUPPLIER == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtSupplier").focus()
      return
    } else if (txn.intTX_CUSTOMER == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtCustomer").focus()
      return
    } else if (txn.intTX_SALESBY == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtSA").focus()
      return
    } else if (txn.intTX_PRICEMODE == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtPriceMode").focus()
      return
    } else if (txn.strTX_REFTYPES != "" && txn.intTX_BOM == 0) {
      document.getElementById("txtRefNo").focus()
      return
    } else if (txn.intTX_BOM == 0) {
      document.getElementById("txtRemarks1") ? document.getElementById("txtRemarks1").focus() : null
      return
    }
  }
  if (e == "txtDeliLoc") {
    if (txn.intTX_SUPPLIER == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtSupplier").focus()
      return
    } else if (txn.intTX_CUSTOMER == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtCustomer").focus()
      return
    } else if (txn.intTX_SALESBY == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtSA").focus()
      return
    } else if (txn.intTX_PRICEMODE == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtPriceMode").focus()
      return
    } else if (txn.strTX_REFTYPES != "" && txn.intTX_BOM == 0) {
      document.getElementById("txtRefNo").focus()
      return
    } else if (txn.intTX_BOM == 0) {
      document.getElementById("txtRemarks1") ? document.getElementById("txtRemarks1").focus() : null
      return
    }
  }
  if (e == "txtSupplier") {
    if (txn.intTX_CUSTOMER == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtCustomer").focus()
      return
    } else if (txn.intTX_SALESBY == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtSA").focus()
      return
    } else if (txn.intTX_PRICEMODE == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtPriceMode").focus()
      return
    } else if (txn.strTX_REFTYPES != "" && txn.intTX_BOM == 0) {
      document.getElementById("txtRefNo").focus()
      return
    } else if (txn.intTX_BOM == 0) {
      document.getElementById("txtRemarks1") ? document.getElementById("txtRemarks1").focus() : null
      return
    }
  }
  if (e == "txtCustomer") {
    if (txn.intTX_SALESBY == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtSA").focus()
      return
    } else if (txn.intTX_PRICEMODE == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtPriceMode").focus()
      return
    } else if (txn.strTX_REFTYPES != "" && txn.intTX_BOM == 0) {
      document.getElementById("txtRefNo").focus()
      return
    } else if (txn.intTX_BOM == 0) {
      document.getElementById("txtRemarks1") ? document.getElementById("txtRemarks1").focus() : null
      return
    }
  }
  if (e == "txtSA") {
    if (txn.intTX_PRICEMODE == 1 && txn.intTX_BOM == 0) {
      document.getElementById("txtPriceMode").focus()
      return
    } else if (txn.strTX_REFTYPES != "" && txn.intTX_BOM == 0) {
      document.getElementById("txtRefNo").focus()
      return
    } else if (txn.intTX_BOM == 0) {
      document.getElementById("txtRemarks1") ? document.getElementById("txtRemarks1").focus() : null
      return
    }
  }
  if (e == "txtPriceMode") {
    if (txn.strTX_REFTYPES != "" && txn.intTX_BOM == 0) {
      document.getElementById("txtRefNo").focus()
      return
    } else if (txn.intTX_BOM == 0) {
      document.getElementById("txtRemarks1") ? document.getElementById("txtRemarks1").focus() : null
      return
    }
  }
  if (e == "txtRefNo" && txn.intTX_BOM == 0) {
    document.getElementById("txtRemarks1") ? document.getElementById("txtRemarks1").focus() : null
    return
  }
  if (e == "txtRemarks1" && txn.intTX_BOM == 0) {
    document.getElementById("txtRemarks2").focus()
    return
  }
}


export const getTransactionTax = async (taxhCode, supCode, txnType) => {

  if (supCode == "" || taxhCode == "") return { data: [], isSuccess: false, msg: "Supplier code is required" }

  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${ApiURL}txn/tax/${taxhCode}/${supCode}/${txnType}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }
    });

    const responseData = await response.json();

    if (responseData.success) {
      return { data: responseData.data, isSuccess: true, msg: responseData.msg };
    } else {
      return { data: [], isSuccess: false, msg: responseData.msg };
    }
  } catch (error) {
    return { data: [], isSuccess: false, msg: responseData.msg };
  }
};




export const handleExcelUpload = async (file, location, supplier, customer, txnType, priceMode) => {
  const formData = new FormData();
  formData.append('excelFile', file);
  formData.append('location', location);
  formData.append('supplier', supplier);
  formData.append('customer', customer);
  formData.append('transaction', txnType);
  formData.append('priceMode', priceMode);

  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  let responseData = []
  let msg = ""
  let status = "0"
  let success = false
  let detailTable = []
  let taxTable = []

  try {
    const response = await fetch(`${ApiURL}ExcelUpload/Transaction`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    });
    const data = await response.json();

    if (response.ok) {
      if (data.success == true) {

        responseData = data.data
        msg = data.msg
        status = data.status
        success = data.success
        detailTable = data.details
        taxTable = JSON.parse(data.taxdetails)

      } else {

        msg = data.msg
        status = data.status
        success = data.success
        detailTable = []
        taxTable = []

      }
    } else {

      msg = data.msg
      status = "0"
      success = false
      detailTable = []
      taxTable = []

    }

    return { success: success, data: responseData, message: msg, status: status, detailTable: detailTable, taxTable: taxTable }

  } catch (error) {
    console.error('Error uploading file:', error);
    return { success: false, data: responseData, message: msg, status: status, detailTable: detailTable, taxTable: taxTable }
    // Handle errors
  }
};



export const getMobileManDocumentDetails = async (refTypeSelected, LogUserType, fromLocationSelect, RefCode, type) => {

  if (refTypeSelected == "" || RefCode == "") return { data: [], isSuccess: false, msg: "Select Reference Code" }

  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${ApiURL}txn/mobileman/${refTypeSelected}/${LogUserType}/${fromLocationSelect}/${RefCode}/${type}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    const responseData = await response.json();

    if (responseData.success) {
      return { data: responseData.data, isSuccess: true, msg: responseData.msg };
    } else {
      return { data: [], isSuccess: false, msg: responseData.msg };
    }
  } catch (error) {
    return { data: [], isSuccess: false, msg: responseData.msg };
  }
};


export const getMobileManDocumentDetailsUserWise = async (refTypeSelected, LogUserType, fromLocationSelect, RefCode, type) => {

  if (refTypeSelected == "" || RefCode == "") return { data: [], isSuccess: false, msg: "Select Reference Code" }

  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${ApiURL}txn/mobilemanuser_wise/${refTypeSelected}/${LogUserType}/${fromLocationSelect}/${RefCode}/${type}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    const responseData = await response.json();

    if (responseData.success) {
      return { data: responseData.data, isSuccess: true, msg: responseData.msg };
    } else {
      return { data: [], isSuccess: false, msg: "No Data Found!" };
    }
  } catch (error) {
    return { data: [], isSuccess: false, msg: error };
  }
};



export const getSupplierCredit = async (supplier) => {

  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${ApiURL}txn/supplierCredit`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ supplier: supplier })
      }
    );

    const responseData = await response.json();

    if (responseData.success) {
      return { creditAmount: responseData.creditAmount, outstandingAmount: responseData.outstandingAmount, isSuccess: true, msg: responseData.msg };
    } else {
      return { creditAmount: 0, outstandingAmount: 0, isSuccess: false, msg: responseData.msg };
    }

  } catch (error) {
    return { creditAmount: 0, outstandingAmount: 0, isSuccess: false, msg: error };
  }
};



export const modifyGridTable = async (dataTable, txnDecimalQty, txnDecimalAmt, txn) => {
  var newGrid = []

  dataTable.map((item, index) => {
    var newRow = item
    newRow.id = item.dcDET_LINENO
    newRow.disable = true
    newRow.dcDET_ACOST = parseFloat(item.dcDET_ACOST).toFixed(txnDecimalAmt)
    newRow.dcDET_APRICE = parseFloat(item.dcDET_APRICE).toFixed(txnDecimalAmt)
    newRow.dcDET_BALQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_BALQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_BALQTY).toFixed(0)
    newRow.dcDET_FBALQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_FBALQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_FBALQTY).toFixed(0)
    newRow.dcDET_CASEQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_CASEQTY).toFixed(0) : parseFloat(item.dcDET_CASEQTY).toFixed(0)
    newRow.dcDET_CPRICE = parseFloat(item.dcDET_CPRICE).toFixed(txnDecimalAmt)
    newRow.dcDET_CS = parseFloat(item.dcDET_CS).toFixed(0)
    newRow.dcDET_DISCAMT = parseFloat(item.dcDET_DISCAMT).toFixed(txnDecimalAmt)
    newRow.dcDET_DISCPER = parseFloat(item.dcDET_DISCPER).toFixed(txnDecimalAmt)
    newRow.dcDET_FCASEQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_FCASEQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_FCASEQTY).toFixed(0)
    newRow.dcDET_FUNITQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_FUNITQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_FUNITQTY).toFixed(0)
    newRow.dcDET_OAPRICE = parseFloat(item.dcDET_OAPRICE).toFixed(txnDecimalAmt)
    newRow.dcDET_OCPRICE = parseFloat(item.dcDET_OCPRICE).toFixed(txnDecimalAmt)
    newRow.dcDET_OSPRICE = parseFloat(item.dcDET_OSPRICE).toFixed(txnDecimalAmt)
    newRow.dcDET_SPRICE = parseFloat(item.dcDET_SPRICE).toFixed(txnDecimalAmt)
    newRow.dcDET_SYSQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_SYSQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_SYSQTY).toFixed(0)
    newRow.dcDET_UNITQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_UNITQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_UNITQTY).toFixed(0)
    newRow.dcDET_VARQTY = parseFloat(item.dcDET_VARQTY).toFixed(txnDecimalQty),
      newRow.dcDET_CPRICE_OLD = parseFloat(item.dcDET_OCPRICE).toFixed(txnDecimalAmt)
    newRow.dcDET_SPRICE_OLD = parseFloat(item.dcDET_OSPRICE).toFixed(txnDecimalAmt)
    newRow.isDecimal = item.isDecimal
    newGrid.push(newRow)
  })

  newGrid.sort((a, b) => a.id - b.id);

  return newGrid;

}



export const creteTwoObjectsOfGrid = async () => {


  var dataRow = {
    dcDET_ACOST: 0,
    dcDET_AMOUNT: 0,
    dcDET_APRICE: 0,
    dcDET_BALQTY: 0,
    dcDET_FBALQTY: 0,
    dcDET_CASEQTY: 0,
    dcDET_CPRICE: 0,
    dcDET_CS: 1,
    dcDET_DISCAMT: 0,
    dcDET_DISCPER: 0,
    dcDET_FCASEQTY: 0,
    dcDET_FUNITQTY: 0,
    dcDET_OAPRICE: 0,
    dcDET_OCPRICE: 0,
    dcDET_OSPRICE: 0,
    dcDET_SPRICE: 0,
    dcDET_SYSQTY: 0,
    dcDET_UNITQTY: 0,
    dcDET_VARQTY: 0,
    dtDET_EXPCHECK: 0,
    dtDET_ISBATCH: 0,
    dtDET_EXPDAET: "1900-01-01",
    strDET_COMCODE: "",
    strDET_EXPBATCH: "",
    strDET_LOCCODE: "",
    strDET_PROCODE: "",
    strDET_PROCOLOR: "",
    strDET_PRODESC: "",
    strDET_PROSIZE: "",
    strDET_REMCODE: "",
    strDET_RUNNO: "",
    strDET_SACODE: "",
    strDET_STOCKCODE: "",
    strDET_TYPE: "",
    strDET_UNIT: "",
    disable: false,
    variant_ENABLE: false,
    dcDET_SPRICE_OLD: 0,
    dcDET_CPRICE_OLD: 0,
    isDecimal: 0,
    dbPackPrice: 0,
    id: 1,
    openItem: 0,
    innerCS: [],
    defaultCS: 1,
    fixGP: 0,
  }


  const copy1 = { ...dataRow };


  const copy2 = { ...dataRow };


  // Now you have two separate objects with different ids
  return [copy1, copy2];


}



export const updateObjectWithData = async (item, PRODUCT, referenceItem, txn, txnDecimalAmt, txnDecimalQty, reasonForDetails, rowID = 1) => {

  item.id = referenceItem ? referenceItem.id : rowID


  item.strDET_PROCODE = PRODUCT.strProductCode
  item.strDET_PRODESC = PRODUCT.strProductDesc
  item.strDET_STOCKCODE = PRODUCT.strStockCode
  item.dtDET_EXPCHECK = PRODUCT.isExp
  item.isDecimal = PRODUCT.isDecimal

  if (txn.intTX_FIFO == 1) {

    item.dcDET_CPRICE = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
    item.dcDET_SPRICE = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
    item.dcDET_SPRICE_OLD = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
    item.dcDET_CPRICE_OLD = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
    item.dbPackPrice = parseFloat(PRODUCT.dbPackPrice).toFixed(txnDecimalAmt)
    item.dbAvgCost = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_ACOST = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_ACOST_OLD = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_SYSQTY = parseFloat(PRODUCT.dbSIH).toFixed(txnDecimalQty)
    item.dcDET_OCPRICE = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
    item.dcDET_OSPRICE = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
    item.dcDET_OAPRICE = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_APRICE = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_CASEQTY = 0
    item.dcDET_UNITQTY = 0
    item.dcDET_BALQTY = 0
    item.dcDET_FBALQTY = 0

  } else if (txn.intTX_REFPRICE == 1 && referenceItem != null) {

    item.dcDET_CPRICE = parseFloat(referenceItem.dcDET_CPRICE).toFixed(txnDecimalAmt)
    item.dcDET_SPRICE = parseFloat(referenceItem.dcDET_SPRICE).toFixed(txnDecimalAmt)
    item.dcDET_SPRICE_OLD = parseFloat(referenceItem.dcDET_SPRICE).toFixed(txnDecimalAmt)
    item.dcDET_CPRICE_OLD = parseFloat(referenceItem.dcDET_CPRICE).toFixed(txnDecimalAmt)
    item.dbPackPrice = parseFloat(referenceItem.dcDET_SPRICE).toFixed(txnDecimalAmt)
    item.dcDET_SYSQTY = parseFloat(referenceItem.dcDET_SYSQTY).toFixed(txnDecimalQty)
    item.dcDET_ACOST = parseFloat(referenceItem.dcDET_ACOST).toFixed(txnDecimalAmt)
    item.dcDET_ACOST_OLD = parseFloat(referenceItem.dcDET_ACOST).toFixed(txnDecimalAmt)
    item.dbAvgCost = parseFloat(referenceItem.dcDET_ACOST).toFixed(txnDecimalAmt)
    item.dcDET_OCPRICE = parseFloat(referenceItem.dcDET_OCPRICE).toFixed(txnDecimalAmt)
    item.dcDET_OSPRICE = parseFloat(referenceItem.dcDET_OSPRICE).toFixed(txnDecimalAmt)
    item.dcDET_OAPRICE = parseFloat(referenceItem.dcDET_OAPRICE).toFixed(txnDecimalAmt)
    item.dcDET_APRICE = parseFloat(referenceItem.dcDET_ACOST).toFixed(txnDecimalAmt)
    item.dcDET_CASEQTY = referenceItem.dcDET_CASEQTY
    item.dcDET_UNITQTY = referenceItem.dcDET_UNITQTY
    item.dcDET_BALQTY = referenceItem.dcDET_BALQTY
    item.dcDET_FBALQTY = referenceItem.dcDET_FBALQTY

  } else {

    item.dcDET_CPRICE = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
    item.dcDET_SPRICE = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
    item.dcDET_SPRICE_OLD = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
    item.dcDET_CPRICE_OLD = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
    item.dbPackPrice = parseFloat(PRODUCT.dbPackPrice).toFixed(txnDecimalAmt)
    item.dbAvgCost = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_ACOST = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_ACOST_OLD = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_SYSQTY = parseFloat(PRODUCT.dbSIH).toFixed(txnDecimalQty)
    item.dcDET_OCPRICE = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
    item.dcDET_OSPRICE = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
    item.dcDET_OAPRICE = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_APRICE = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
    item.dcDET_CASEQTY = 0
    item.dcDET_UNITQTY = 0
    item.dcDET_BALQTY = referenceItem != null ? referenceItem.dcDET_BALQTY : 0
    item.dcDET_FBALQTY = referenceItem != null ? referenceItem.dcDET_FBALQTY : 0

  }

  item.dcDET_CS = PRODUCT.dbCaseSize != 0 ? PRODUCT.dbCaseSize : 1
  item.strDET_UNIT = PRODUCT.strUnitDesc
  item.openItem = PRODUCT.isOpen
  item.dtDET_ISBATCH = PRODUCT.batchEnable
  item.dtDET_EXPDAET = PRODUCT.pluExpiery.slice(0, 10)
  item.disable = true
  item.strDET_REMCODE = reasonForDetails != null && reasonForDetails != "" ? reasonForDetails : ""

  return item;
}





export const findItemReferenceForNewArray = (strDET_PROCODE = "", strDET_STOCKCODE = "", referenceArray = [], currentArray = [], txn) => {
  // Find the items in the original array with matching strDET_PROCODE and strDET_STOCKCODE

  if (referenceArray.length == 0) {
    return null;
  }

  const existingItems = referenceArray.filter(i => i.strDET_PROCODE == strDET_PROCODE && i.strDET_STOCKCODE == strDET_STOCKCODE);

  // Filter out the items that have already been added to the new array based on the id
  const addedItemIds = currentArray
    .filter(i => i.strDET_PROCODE != "" && i.strDET_STOCKCODE != "")  // Filter out items with empty strDET_PROCODE
    .map(i => i.id);
  const availableItems = existingItems.filter(i => !addedItemIds.includes(i.id));

  // If no available items, return null (i.e., item has been added the maximum number of times)
  if (availableItems.length == 0) {

    if (txn.intTX_IS_LIQUOR != 0) { // If liquor transaction, return the first available item (based on the first available item in the filtered list) even if it has been added before
      return existingItems ? existingItems[0] : null;
    }

    return null;
  }

  // Return the next available item (based on the first available item in the filtered list)
  return availableItems[0];
}




export const getConsignmnetDatail = async (supplier, fromDate, toDate, txnType, fromLocation, toLocation) => {

  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${ApiURL}txn/Consignment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          supplier: supplier,
          fromDate: fromDate,
          toDate: toDate,
          txnType: txnType,
          fromLocation: fromLocation,
          toLocation: toLocation
        })
      }
    );

    const responseData = await response.json();

    if (responseData.success) {
      return { data: responseData.detail, reference: responseData.reference, isSuccess: true, message: responseData.message };
    } else {
      return { data: [], reference: "", isSuccess: false, message: responseData.message };
    }

  } catch (error) {
    return { data: [], reference: "", isSuccess: false, message: error };
  }
};



export const exportTransactionDataToExcel = async (DataRow, supplier, customer, salesAssistant, remark1, remark2, txnType) => {

  const newArray = DataRow.map(data => ({
    DET_LINENO: parseFloat(data.id),
    DET_PROCODE: data.strDET_PROCODE,
    DET_PRODESC: data.strDET_PRODESC,
    DET_STOCKCODE: data.strDET_STOCKCODE,
    DET_UNIT: data.strDET_UNIT,
    DET_CS: parseFloat(data.dcDET_CS),
    DET_UNITQTY: parseFloat(data.dcDET_UNITQTY == null ? 0 : data.dcDET_UNITQTY),
    DET_CPRICE: parseFloat(data.dcDET_CPRICE == null ? 0 : data.dcDET_CPRICE),
    DET_SPRICE: parseFloat(data.dcDET_SPRICE == null ? 0 : data.dcDET_SPRICE),
    DET_ACOST: parseFloat(data.dcDET_ACOST == null ? 0 : data.dcDET_ACOST),
    DET_AMOUNT: parseFloat(data.dcDET_AMOUNT == null ? 0 : data.dcDET_AMOUNT),
    DET_APRICE: parseFloat(data.dcDET_APRICE == null ? 0 : data.dcDET_APRICE),
    DET_BALQTY: parseFloat(data.dcDET_BALQTY == null ? 0 : data.dcDET_BALQTY),
    DET_CASEQTY: parseFloat(data.dcDET_CASEQTY == null ? 0 : data.dcDET_CASEQTY),
    DET_DISCAMT: parseFloat(data.dcDET_DISCAMT == null ? 0 : data.dcDET_DISCAMT),
    DET_DISCPER: parseFloat(data.dcDET_DISCPER == null ? 0 : data.dcDET_DISCPER),
    DET_FCASEQTY: parseFloat(data.dcDET_FCASEQTY == null ? 0 : data.dcDET_FCASEQTY),
    DET_FUNITQTY: parseFloat(data.dcDET_FUNITQTY == null ? 0 : data.dcDET_FUNITQTY),
    DET_OAPRICE: parseFloat(data.dcDET_OAPRICE == null ? 0 : data.dcDET_OAPRICE),
    DET_OCPRICE: parseFloat(data.dcDET_OCPRICE == null ? 0 : data.dcDET_OCPRICE),
    DET_OSPRICE: parseFloat(data.dcDET_OSPRICE == null ? 0 : data.dcDET_OSPRICE),
    DET_SYSQTY: parseFloat(data.dcDET_SYSQTY == null ? 0 : data.dcDET_SYSQTY),
    DET_VARQTY: parseFloat(data.dcDET_VARQTY == null ? 0 : data.dcDET_VARQTY),
    DET_EXPDAET: data.dtDET_EXPDAET == null ? "1900-01-01" : data.dtDET_EXPDAET,
    DET_COMCODE: data.strDET_COMCODE == null ? "" : data.strDET_COMCODE,
    DET_EXPBATCH: data.strDET_EXPBATCH == null ? "" : data.strDET_EXPBATCH,
    DET_LOCCODE: data.strDET_LOCCODE == null ? "" : data.strDET_LOCCODE,
    DET_PROCOLOR: data.strDET_PROCOLOR == null ? "" : data.strDET_PROCOLOR,
    DET_PROSIZE: data.strDET_PROSIZE == null ? "" : data.strDET_PROSIZE,
    DET_REMCODE: data.strDET_REMCODE == null ? "" : data.strDET_REMCODE,
    DET_RUNNO: data.strDET_RUNNO == null ? "" : data.strDET_RUNNO,
    DET_SACODE: data.strDET_SACODE == null ? "" : data.strDET_SACODE,
    DET_TYPE: data.strDET_TYPE == null ? "" : data.strDET_TYPE,
  }));

  try {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    const response = await fetch(`${ApiURL}ExcelUpload/exportTxnDetails`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${authToken}`,
        "Content-Type": "application/json" // Add Content-Type header
      },
      redirect: "follow",
      body: JSON.stringify({
        txnType: txnType,
        supplier: supplier,
        customer: customer,
        salesAssistant: salesAssistant,
        remark1: remark1,
        remark2: remark2,
        details: newArray
      })
    });

    // Check if the request was successful (status code in the range of 200-299)
    if (response.ok) {

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'downloaded-file.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true

    } else {
      const errorData = await response.json(); // Assuming the server returns JSON
      console.error('Error:', errorData);
      return false
    }
  } catch (error) {
    console.error('Fetch error:', error);
    return false
  }

}


export const ValidateFreeQty = async (productCode, supplier, proQty) => {

  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  try {
    const response = await fetch(`${ApiURL}txn/validateFreeQty`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        productCode: productCode,
        supplier: supplier,
        proQty: parseFloat(proQty),
      }),
      redirect: "follow",
    });

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("Error:", error);
    return 0; // Return an empty array in case of an error
  }

};


export const spQtyUploadValidation = async (file, location) => {
  const formData = new FormData();
  formData.append('excelFile', file);
  formData.append('location', location);

  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  try {
    const response = await fetch(`${ApiURL}txn/excel_qty_upload`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    });

    if (response.ok) {
      const data = await response.json();
      return { success: true, data: data.data, msg: data.msg };
    } else {
      return { success: false, data: [], msg: 'Failed to upload file' };
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    return { success: false, data: [], msg: 'Error uploading file' };
    // Handle errors
  }
};